import { ChainedCommands, Editor } from '@tiptap/core';

import {
  EDITOR_ACTION_IDS,
  EditorActionId,
} from 'src/components/tiptap/constants';

export interface ActionHandlers {
  action: () => boolean;
  canRunAction: () => boolean;
}

export const createActionHandlers = (
  editor: Editor,
  command: (chain: ChainedCommands) => boolean,
): ActionHandlers => ({
  action: () =>
    editor
      .chain()
      .command(({ chain }) => command(chain()))
      .run(),
  canRunAction: () =>
    editor
      .can()
      .chain()
      .command(({ chain }) => command(chain()))
      .run(),
});

/**
 * Executes a tiptap editor action based on the action ID.
 * Centralizes the mapping between action IDs and their corresponding editor commands.
 */
export const executeEditorAction = (
  editor: Editor,
  actionId: EditorActionId | string,
): boolean => {
  const actionMap: Record<string, () => boolean> = {
    [EDITOR_ACTION_IDS.BOLD]: () => editor.chain().focus().toggleBold().run(),
    [EDITOR_ACTION_IDS.ITALIC]: () =>
      editor.chain().focus().toggleItalic().run(),
    [EDITOR_ACTION_IDS.UNDERLINE]: () =>
      editor.chain().focus().toggleUnderline().run(),
    [EDITOR_ACTION_IDS.STRIKE]: () =>
      editor.chain().focus().toggleStrike().run(),
    [EDITOR_ACTION_IDS.BULLET_LIST]: () =>
      editor.chain().focus().toggleBulletList().run(),
    [EDITOR_ACTION_IDS.ORDERED_LIST]: () =>
      editor.chain().focus().toggleOrderedList().run(),
  };

  return actionMap[actionId]?.() ?? false;
};
